import {
  getDaysUntilNextWeek,
  getNextWeeksChallenges,
} from "@/lib/weeklyChallenges";
import { useAppStore } from "@/store/useAppStore";
import React from "react";

export const WeeklyRefreshNotice = () => {
  const { allWeekCompleted } = useAppStore();
  return (
    <div className="text-center mt-8 p-4 bg-white/5 rounded-xl border border-white/10">
      {allWeekCompleted ? (
        <div>
          <p className="text-sm text-green-400 font-semibold mb-2">
            ✅ Great job! You've completed all of this week's challenges!
          </p>
          <p className="text-sm text-gray-300">
            🔄 Come back in {getDaysUntilNextWeek()} days for 4 new behavioral
            economics puzzles.
          </p>
          <button
            onClick={() => {
              const nextWeek = getNextWeeksChallenges();
              const titles = nextWeek.map((c: any) => c.title).join(", ");
              alert(`Next week's challenges: ${titles}`);
            }}
            className="mt-2 text-xs text-brand-light hover:text-brand-accent underline"
          >
            Preview next week's challenges →
          </button>
        </div>
      ) : (
        <p className="text-sm text-gray-300">
          🔄 Challenges refresh weekly every Monday. Complete all 4 challenges
          before the week ends!
        </p>
      )}
    </div>
  );
};
